import {
    LOADING_CANVA,
    WAITING_DATA_CANVA,
    BAR_HIDDEN_CANVA,
    IS_SIDEBAR_HOME_CANVA,
    IS_VISITA_MAP_CANVA,
    SHOWED_MAP_CANVA,
    SELECTED_TORRE_CANVA,
    SELECTED_APTO_TIPO_CANVA,
    INDEX_APTO_TIPO_CANVA,
    TIPOS_APTOS_COTIZADOS_CANVA,
    SELECTED_APTOS_CANVA,
    SELECTED_FLOOR_CANVA,
    APTO_TIPO_OPENED_CANVA,
    OPEN_GALERIA_CANVA,
    OPEN_360_CANVA,
    SELECTED_POI_CANVA,
    IS_FORM_COTIZACION_CANVA,
    LINKS_CANVA,
    LINK_TRANSITION_CANVA,
    IS_TRANCITION_CANVA,
    INIT_FRAME_POI_CANVA,
    IS_PRE_TRANSITION_CANVA,

    APTOS_COTIZADOS_CANVA,

    IS_180_CANVA,
    SHOW_GENERAL_VIEW_CANVA,
    IS_IMAGE_360_CANVA,
    SHOW_BUBBLES_CANVA,
    SHOW_BILLBOARDS_CANVA,

    CATEGORY_FILTER_CANVA,
    TORRE_FILTER_CANVA,
    APTO_FILTER_CANVA,
    AMENITY_CANAVA,
    SHOWING_TORRES_SPIN_CANVA,
    TOWER_TRANSITION_CANVA,

    ROTATE_FOR_BUBBLE_CANVA,

    SELECTED_ZONA_INTERES_CANVA,
} from '../actions';

const INIT_STATE = {
    loading: true,
    waitingForData: true,
    barHidden: false,
    isSidebarHome: true,
    isVistaMap: false,

    showedMap: "vias-map",
    selectedTorre: -1,
    selectedAptoTipo: {},
    indexAptoTipo: 0,
    tiposAptosCotizados: [],
    selectedApto: -1,

    aptotipoOpened: false,
    openGaleria: false,
    open360: false,
    selectedPOI: {},
    isFormCotizacion: false,
    //
    links: [],
    linkTransition: [],
    isTransicion: false,
    initFramePOI: 0,
    isPreTransition: false,

    aptosCotizados: [],

    is180: false,
    showGeneralView: true,
    isImage360: false,
    showBubbles: false,
    showBillboards: false,

    categoryFilter: "",
    torreFilter: "",
    aptoFilter: "",
    amenity: "",
    showingTorresSpin: false,
    towerTransition: false,

    rotateForBubble: false,

    selectedZonaInteres: [],

    error: ''
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case LOADING_CANVA:
            return {
                ...state, loading: action.payload, error: ''
            };
        case WAITING_DATA_CANVA:
            return {
                ...state, waitingForData: action.payload, error: ''
            };
        case BAR_HIDDEN_CANVA:
            return {
                ...state, barHidden: action.payload, error: ''
            };
        case IS_SIDEBAR_HOME_CANVA:
            return {
                ...state, isSidebarHome: action.payload, error: ''
            };
        case IS_VISITA_MAP_CANVA:
            return {
                ...state, isVistaMap: action.payload, error: ''
            };
        case SHOWED_MAP_CANVA:
            return {
                ...state, showedMap: action.payload, error: ''
            };
        case SELECTED_TORRE_CANVA:
            return {
                ...state, selectedTorre: action.payload, error: ''
            };
        case SELECTED_APTO_TIPO_CANVA:
            return {
                ...state, selectedAptoTipo: action.payload, error: ''
            };
        case INDEX_APTO_TIPO_CANVA:
            return {
                ...state, indexAptoTipo: action.payload, error: ''
            };
        case TIPOS_APTOS_COTIZADOS_CANVA:
            return {
                ...state, tiposAptosCotizados: action.payload, error: ''
            };
        case SELECTED_APTOS_CANVA:
            return {
                ...state, selectedApto: action.payload, error: ''
            };
        case SELECTED_FLOOR_CANVA:
            return {
                ...state, selectedFloor: action.payload, error: ''
            };
        case APTO_TIPO_OPENED_CANVA:
            return {
                ...state, aptotipoOpened: action.payload, error: ''
            };
        case OPEN_GALERIA_CANVA:
            return {
                ...state, openGaleria: action.payload, error: ''
            };
        case OPEN_360_CANVA:
            return {
                ...state, open360: action.payload, error: ''
            };
        case SELECTED_POI_CANVA:
            return {
                ...state, selectedPOI: action.payload, error: ''
            };
        case IS_FORM_COTIZACION_CANVA:
            return {
                ...state, isFormCotizacion: action.payload, error: ''
            };
        case LINKS_CANVA:
            return {
                ...state, links: action.payload, error: ''
            };
        case LINK_TRANSITION_CANVA:
            return {
                ...state, linkTransition: action.payload, error: ''
            };
        case IS_TRANCITION_CANVA:
            return {
                ...state, isTransicion: action.payload, error: ''
            };
        case INIT_FRAME_POI_CANVA:
            return {
                ...state, initFramePOI: action.payload, error: ''
            };
        case IS_PRE_TRANSITION_CANVA:
            return {
                ...state, isPreTransition: action.payload, error: ''
            };
        case APTOS_COTIZADOS_CANVA:
            return {
                ...state, aptosCotizados: action.payload, error: ''
            };
        case IS_180_CANVA:
            return {
                ...state, is180: action.payload, error: ''
            };
        case SHOW_GENERAL_VIEW_CANVA:
            return {
                ...state, showGeneralView: action.payload, error: ''
            };
        case IS_IMAGE_360_CANVA:
            return {
                ...state, isImage360: action.payload, error: ''
            };
        case SHOW_BUBBLES_CANVA:
            return {
                ...state, showBubbles: action.payload, error: ''
            };
        case SHOW_BILLBOARDS_CANVA:
            return {
                ...state, showBillboards: action.payload, error: ''
            };
        case CATEGORY_FILTER_CANVA:
            return {
                ...state, categoryFilter: action.payload, error: ''
            };
        case TORRE_FILTER_CANVA:
            return {
                ...state, torreFilter: action.payload, error: ''
            };
        case APTO_FILTER_CANVA:
            return {
                ...state, aptoFilter: action.payload, error: ''
            };
        case AMENITY_CANAVA:
            return {
                ...state, amenity: action.payload, error: ''
            };
        case SHOWING_TORRES_SPIN_CANVA:
            return {
                ...state, showingTorresSpin: action.payload, error: ''
            };
        case TOWER_TRANSITION_CANVA:
            return {
                ...state, towerTransition: action.payload, error: ''
            };
        case ROTATE_FOR_BUBBLE_CANVA:
            return {
                ...state, rotateForBubble: action.payload, error: ''
            };
        case SELECTED_ZONA_INTERES_CANVA:
            return {
                ...state, selectedZonaInteres: action.payload, error: ''
            };
        default:
            return {
                ...state
            };
    }
}